import styled from 'styled-components';
import {
  Radio as SemanticRadio,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Main = styled.div`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px;
  max-width: 450px;
  padding-bottom: 10px;
  width: auto;
`;

const Heading = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  margin: 0 25px;
  text-align: center;
`;

const SubHeading = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.primary};
  font-size: 13px;
  margin: 10px 0;
  text-align: center;
`;

const Text = styled(TextLayoutComponent)``;

const TextHeader = styled(TextLayoutComponent.Header)`
  font-size: 18px;
`;

const SmallText = styled(TextLayoutComponent)`
  font-size: 10px;
  margin-bottom: 10px;
`;

const SignUpButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-bottom: 50px;
    margin-top: 60px;
    min-width: 100px;
  }
`;

const PaymentMethodContainer = styled.div`
  margin-bottom: 20px;

  div:first-of-type {
    margin-top: 5px;
  }
`;

const FullWidth = styled.div`
  width: 100%;
  align-items: center;
`;

const ErrorMessage = styled(TextLayoutComponent.Error)`
  :first-child {
    margin-top: 40px;
    margin-bottom: 20px;
    text-align: center;
  }
`;

const DangerText = styled(TextLayoutComponent.Header)`
  color: ${(props) => props.theme.color.textErrorProjetSetUp};
  font-size: 18px;
  margin-bottom: 10px;
`;

const NotificationHeader = styled(TextLayoutComponent.Header)`
  color: #000000;
  font-size: 18px;
  margin-bottom: 10px;
`;

const DeleteAccountContainer = styled.div``;

const NotificationContainer = styled.div`
  margin-bottom: 50px;
`;

const DeleteText = styled(TextLayoutComponent)``;

const NotificationText = styled(TextLayoutComponent)`
  margin-bottom: 10px;
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const DeleteButton = styled(ButtonLayoutComponent.Danger)``;

const Radio = styled(SemanticRadio)`
  padding-right: 10px;
`;

export {
  ErrorMessage,
  FullWidth,
  Heading,
  Main,
  PaymentMethodContainer,
  SignUpButton,
  SmallText,
  SubHeading,
  Text,
  TextHeader,
  DangerText,
  DeleteAccountContainer,
  DeleteText,
  DeleteButton,
  ContainerButton,
  NotificationText,
  NotificationContainer,
  Radio,
  NotificationHeader,
};
